function onOpenDialog(id) {
    let dialog = document.querySelector(`[data-dialog='${id}']`);
    let trigger = document.querySelector(`[aria-controls='${id}']`);
    if (dialog) {
        dialog.classList.toggle('.hide');
        dialog.showModal();
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
        }
        setTimeout(() => {
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }, 0);
    } else {
        console.error('Dialog element not found');
    }
}

function onCloseDialog() {
    let openDialog = document.querySelector('dialog[open]');
    if (openDialog) {
        let dialogId = openDialog.getAttribute('data-dialog');
        let trigger = document.querySelector(`[aria-controls='${dialogId}']`);
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
        }
        openDialog.close();
    }
}

document.addEventListener('DOMContentLoaded', function () {
    let closeButtons = document.querySelectorAll('.closeModal');
    closeButtons.forEach(button => {
        button.addEventListener('click', function () {
            document.body.classList.remove('Globo-not-scroll');
            onCloseDialog();
        });
    });

    let dialogs = document.querySelectorAll('dialog');
    dialogs.forEach(dialog => {
        dialog.addEventListener('click', function (event) {
            // Check if the event target is exactly the dialog element, not its descendants
            if (event.target === dialog) {
                dialog.close();
            }
        });

        // Optionally, stop propagation of click events from the dialog's content area
        const contentArea = dialog.querySelector('.dialog-content');
        if (contentArea) {
            contentArea.addEventListener('click', function (event) {
                event.stopPropagation(); // Prevents the click from bubbling up to the dialog element
            });
        }
    });
});

function accountDialogPosition() {
    //This does not affect mobile displays
    if (window.innerWidth < 768) {
        return;
    }

    var accountIcon = document.getElementsByClassName('site-header__account')[0];
    var dialog = document.querySelector(`[data-dialog='customDialog-accountpopup']`);

    // Getting the icon position
    var rect = accountIcon.getBoundingClientRect();

    // Positioning the dialog
    dialog.style.left = rect.left - 115 + 'px'; // Aligned center
}

window.addEventListener('load', accountDialogPosition);